// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/actionable_error.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * ActionableErrorDetails provides structured error information that can be
 * attached to any Connect RPC error via err.AddDetail(). The frontend uses
 * this to render actionable UI (buttons, links, guidance) instead of raw
 * error strings.
 *
 * This is a standalone detail message — it does not modify the environment
 * status proto or any existing message. It follows the same pattern as
 * ParseContextURLPreconditionFailureDetails and PolicyEnforcedFailedPreconditionDetails.
 *
 * @generated from message gitpod.v1.ActionableErrorDetails
 */
export class ActionableErrorDetails extends Message<ActionableErrorDetails> {
  /**
   * Machine-readable error code for programmatic handling.
   * Convention: COMPONENT_CATEGORY_SPECIFIC (e.g. CONTENT_GIT_ACCESS_DENIED).
   *
   * @generated from field: string error_code = 1;
   */
  errorCode = "";

  /**
   * Human-readable message for end-users, replacing the raw error string.
   *
   * @generated from field: string user_message = 2;
   */
  userMessage = "";

  /**
   * Domain-specific metadata relevant to this error type.
   * Keys are domain-specific (e.g. "git_host", "repository_url", "policy_name").
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string } = {};

  /**
   * Actions the user can take to resolve the error.
   *
   * @generated from field: repeated gitpod.v1.ErrorAction actions = 4;
   */
  actions: ErrorAction[] = [];

  constructor(data?: PartialMessage<ActionableErrorDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ActionableErrorDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "error_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "actions", kind: "message", T: ErrorAction, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActionableErrorDetails {
    return new ActionableErrorDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActionableErrorDetails {
    return new ActionableErrorDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActionableErrorDetails {
    return new ActionableErrorDetails().fromJsonString(jsonString, options);
  }

  static equals(a: ActionableErrorDetails | PlainMessage<ActionableErrorDetails> | undefined, b: ActionableErrorDetails | PlainMessage<ActionableErrorDetails> | undefined): boolean {
    return proto3.util.equals(ActionableErrorDetails, a, b);
  }
}

/**
 * ErrorAction describes a single action a user can take to resolve an error.
 *
 * @generated from message gitpod.v1.ErrorAction
 */
export class ErrorAction extends Message<ErrorAction> {
  /**
   * Machine-readable action identifier (e.g. "configure_git_auth", "view_docs").
   *
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * Human-readable button label (e.g. "Configure Git Authentication").
   *
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * Navigation target for this action.
   *
   * @generated from oneof gitpod.v1.ErrorAction.target
   */
  target: {
    /**
     * Internal dashboard route (e.g. "/settings/git-authentication").
     *
     * @generated from field: string dashboard_path = 3;
     */
    value: string;
    case: "dashboardPath";
  } | {
    /**
     * External URL (e.g. "https://ona.com/docs/...").
     *
     * @generated from field: string external_url = 4;
     */
    value: string;
    case: "externalUrl";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ErrorAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ErrorAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dashboard_path", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "target" },
    { no: 4, name: "external_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "target" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ErrorAction {
    return new ErrorAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ErrorAction {
    return new ErrorAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ErrorAction {
    return new ErrorAction().fromJsonString(jsonString, options);
  }

  static equals(a: ErrorAction | PlainMessage<ErrorAction> | undefined, b: ErrorAction | PlainMessage<ErrorAction> | undefined): boolean {
    return proto3.util.equals(ErrorAction, a, b);
  }
}

